/**
 * Поисковые параметры
 */

import { fromJS } from 'immutable';

import { START_SEARCH_PROCESS } from '../../routes/SearchPage/constants/search';
import { COMMIT_SEARCH_PARAMS } from '../../routes/Hotel/store/constants/searchParams';
import { UPDATE_REQUEST_ID } from '../../routes/Hotel/store/constants/searcher';
import { isSSR } from '../../helpers/ssr';
import {
  CLEAR_KIDS,
  CLEAR_START_DATE,
  CLEAR_TOURISTS,
  SET_ADULTS_PARAMS,
  SET_KIDS_PARAMS,
  SET_START_DATE,
} from './constants';

const initialState = fromJS({
  search_params: isSSR ? '' : window.SEARCH_PARAMS,
  request_id: isSSR ? '' : window.REQUEST_ID,
});

export default function enqueueReducer(state = initialState, action) {
  switch (action.type) {
    case START_SEARCH_PROCESS: {
      const { requestId, searchParams } = action.payload || {};

      if (requestId) {
        const newParams = fromJS({
          request_id: requestId,
          search_params: searchParams,
        });
        return state.merge(newParams);
      }
      return state;
    }
    case UPDATE_REQUEST_ID: {
      return state.set('request_id', action.payload);
    }
    case COMMIT_SEARCH_PARAMS: {
      return state.merge({
        search_params: fromJS(action.payload),
      });
    }
    case CLEAR_START_DATE: {
      return state.setIn(['search_params', 'start_date'], undefined);
    }
    case CLEAR_TOURISTS: {
      // Ставим initial значение
      return state.setIn(['search_params', 'adults'], 2);
    }
    case CLEAR_KIDS: {
      return state.setIn(['search_params', 'kids'], { count: 0, ages: [] });
    }
    case SET_START_DATE: {
      return state.setIn(['search_params', 'start_date'], action.payload);
    }
    case SET_ADULTS_PARAMS: {
      return state.setIn(['search_params', 'adults'], action.payload);
    }
    case SET_KIDS_PARAMS: {
      return state.setIn(['search_params', 'kids'], fromJS(action.payload));
    }
    default:
      return state;
  }
}
